@if ((modalService.isOpen$ | async) === true) {
  <div class="relative z-40">
    <!-- Overlay -->
    <button
      type="button"
      class="fixed inset-0 bg-primary-strong/80 transition-opacity"
      (click)="onBackdropClick($event)"
      (keydown)="handleBackdropKeydown($event)"
      aria-label="Cerrar modal"
    ></button>
    @if (modalService.size$ | async; as size) {
      <div
        class="fixed inset-0 z-40 flex justify-center lg:items-center"
        [ngClass]="[
          size !== '5xl' && size !== '7xl' ? 'items-end' : '',
          size === '5xl' ? 'items-start pb-5 pt-12' : '',
          size === '7xl' ? 'items-center pb-5 pt-12' : '',
        ]"
      >
        <div
          class="shadow-xl hide-scrollbar relative w-full transform rounded-lg transition-all"
          [ngClass]="[
            size === 'sm' ? 'sm:max-w-sm' : '',
            size === 'md' ? 'sm:max-w-md' : '',
            size === 'lg' ? 'sm:max-w-lg' : '',
            size === 'xl' ? 'sm:max-w-xl' : '',
            size === '2xl' ? 'sm:max-w-2xl' : '',
            size === '3xl' ? 'sm:max-w-3xl' : '',
            size === '4xl' ? 'sm:max-w-4xl' : '',

            size === '5xl' || size === '7xl'
              ? 'max-h-[90vh] overflow-y-auto sm:max-h-[80vh]'
              : '',

            size === '5xl' ? 'sm:max-w-5xl' : '',

            size === '7xl'
              ? 'mx-5 w-full max-w-7xl bg-white px-5 py-4 lg:py-5'
              : '',

            size !== '5xl' && size !== '7xl'
              ? 'mx-5 bg-white px-5 py-4 lg:py-5'
              : '',
          ]"
          role="alert"
        >
          @if (size !== "5xl") {
            <div class="flex w-full items-center justify-between">
              <h2
                class="font-freightSansProBold text-lg text-primary-normal lg:text-2xl"
              >
                {{ modalService.title$ | async }}
              </h2>
              <button
                type="button"
                (click)="closeModal()"
                class="focus:outline-none"
              >
                <img src="assets/icons/close.svg" alt="Cerrar" />
              </button>
            </div>
          }
          @if (modalService.component$ | async; as dynamicComponent) {
            <ng-container
              *ngComponentOutlet="dynamicComponent; injector: dynamicInjector"
            />
          }
        </div>
      </div>
    }
  </div>
}
